// extracted by mini-css-extract-plugin
export default {"badge":"AiBetaBadge_badge__AmXlR"};